import React, { Component } from 'react';
import store from "store/store";
import { connect } from "react-redux";
import { toast } from 'react-toastify';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import OnboardingTitle from 'components/__new/common/onboardingTitle';
import * as info from "store/entities/settingsInfo/action";
import * as mediaService from "store/ui/mediaService/action";
import { Link } from "react-router-dom";
import DynamicHeadTag from "components/__new/common/DynamicHeadTag";

class GetStartedInfoGeneral extends Component {

    state = {
        employeeFileUpload: "",
        bankStatementFile: "",
        errors: {},
        storeUnsubscribe: "",
    }


    fileUploadChange = (e) => {
        const uploadedFile = e.target.files;
        this.setState({
            employeeFileUpload: uploadedFile,
        });
    }


    filesCheck = (files) => {
        // console.log("files:", files);
        // console.log("files count:", files.length);
        if (files.length === 1){
            return true;
        }
        else if (files.length > 1){
            toast.error("Sorry, only one file can be uploaded at a time.");
        }
        else if (files.length === 0){
            // toast.error("Please upload an MsExcel or CSV file. You can download and use the Employee List CSV Template below.");
            toast.error("Please upload your company's bank statement.");
        }
        else{
            toast.error("An error occurred. Please try again later.");
        }
        return false;
    }


    submitFormUpload = (e) => {
        e.preventDefault();

        const {employeeFileUpload: files} = this.state;
        if (this.filesCheck(files)){

            const file = files[0];
            // console.log("file:", file);
            // console.log("filetype:", file.type);

            let data = new FormData();
            data.append("file", file);

            this.props.uploadFile(data).then(() => {
                const {uploadedFile} = this.props;
                // console.log("uploadedFile", uploadedFile);

                if (uploadedFile.status && uploadedFile.status === "success"){
                    const {url} = uploadedFile.data;
                    this.props.updateBankStatement({bankStatementFile: url});
                }
            })
         
        }
    }


    replaceFile = () => {
        this.setState({bankStatementFile: ""});
    }


    componentDidMount() {
        if(this.props.user.isActive === true){
            this.props.history.push("/dashboard");
            return;
        }

        // check upload status
        this.props.getInfo();

        this.unsubscribe = store.subscribe(() => {
            if ((this.props.getLoading === false) && (this.props.companyInfo) && (Object.keys(this.props.companyInfo).length > 0)){
                this.unsubscribe();

                const {companyInfo: {bankStatementFile}} = this.props;
                if (bankStatementFile !== null){
                    this.setState({bankStatementFile});
                }
            }
        });
        this.setState({storeUnsubscribe: this.unsubscribe});
    }


    componentWillUnmount(){
        const storeUnsubscribe = this.state.storeUnsubscribe;
        if ((storeUnsubscribe !== "") && (storeUnsubscribe !== undefined) && (storeUnsubscribe !== null)){
            storeUnsubscribe();
        }
    }
    
    
    componentDidUpdate(prevProps, prevState) {
        if (this.props.reloadPage === true) {
            this.props.resetReloadPage();
            this.props.history.push("/get-started/info/complete");
        }
    }
    

    render() { 
        const {bankStatementFile} = this.state;

        return (
            <React.Fragment>


                <DynamicHeadTag headerText="Onboarding" />


                <div className="lg:flex">
                    <div className="w-full lg:w-1/2">
                        <div className="page-title">
                            Dashboard
                        </div>
                    </div>
                    <div className="w-full flex mt-2 lg:mt-0 lg:justify-end space-x-3 lg:w-1/2"></div>
                </div>
                
                <div className="mt-6 box">
                    <OnboardingTitle tab="financials" />
                </div>

                <div className="mt-2 box">
                        
                    {(this.props.getLoading === true) && 
                        <div className="">
                            <div className="table-info">
                                <FontAwesomeIcon icon="circle-notch" spin />
                                <div className="font-bold uppercase">
                                    Loading
                                </div>
                            </div>
                        </div>
                    }

                    {(this.props.getLoading === false) && (this.props.companyInfo) && (Object.keys(this.props.companyInfo).length === 0) && 
                        <div className="">
                            <div className="table-info">
                                <FontAwesomeIcon icon="clipboard" />
                                <div className="font-bold uppercase">
                                    Company info not found
                                </div>
                            </div>
                        </div>
                    }

                    {(this.props.getLoading === false) && (this.props.companyInfo) && (Object.keys(this.props.companyInfo).length > 0) && 
                        <div className="max-w-md mx-auto mt-4 mb-8">
                            <form onSubmit={this.submitFormUpload}>

                                <div>
                            
                                    {bankStatementFile === "" &&
                                        <div className="form-group">
                                            <label>
                                                Company’s Bank Statement
                                                <span className="form-input-required">*</span>
                                            </label>
                                            <input type="file" name="employeeFileUpload" id="employeeFileUpload" onChange={this.fileUploadChange} className="form-input" />
                                        </div>
                                    }

                                    {bankStatementFile !== "" &&
                                        <div>
                                            <div>
                                                Bank statement uploaded
                                                <FontAwesomeIcon icon="check-circle" className="text-green-500 ml-1" />
                                            </div>
                                            <div className="mt-2 flex space-x-2">
                                                <Link to={{pathname: bankStatementFile}} target="_blank" className="btn btn-transparent-black">
                                                    View file
                                                </Link>
                                                <div onClick={this.replaceFile} className="btn text-white bg-red-500 cursor-pointer">
                                                    Replace file
                                                </div>
                                            </div>
                                        </div>
                                    }

                                </div>

                                <div className="mt-8 mb-3 text-xs">
                                    The bank statement provided is to see the trend of salary payment over a period of time. No information gotten from business can or will be used for fraudulent purposes.
                                </div>

                                <button type="submit" className="btn btn-lg btn-ep-primary btn-block" disabled={this.props.uploadedFileLoading || this.props.bankStatementLoading}>
                                    <FontAwesomeIcon icon="circle-notch" spin className={"text-xl mr-2 " + (this.props.uploadedFileLoading || this.props.bankStatementLoading?"inline":"hidden")} />
                                    <span>Submit</span>
                                </button>

                            </form>
                        </div>
                    }

                </div>


            </React.Fragment>

        );
    }
}
 

const mapStateToProps = (state) => ({
    user: state.auth.userPersist.data,
    getLoading: state.entities.settingsInfo.getLoading,
    reloadPage: state.entities.settingsInfo.reloadPage,
    companyInfo: state.entities.settingsInfo.companyInfo.company,
    
    uploadedFileLoading: state.ui.mediaService.loading,
    uploadedFile: state.ui.mediaService.uploadedFile,
    
    bankStatementLoading: state.entities.settingsInfo.bankStatementLoading,
    bankStatement: state.entities.settingsInfo.bankStatement,
});

const mapDispatchToProps = (dispatch) => ({
    getInfo: () => dispatch(info.getInfo()),
    uploadFile: (params) => dispatch(mediaService.uploadFile(params)),
    updateBankStatement: (params) => dispatch(info.updateBankStatement(params)),
    resetReloadPage: () => dispatch(info.resetReloadPage()),
});

export default connect(mapStateToProps, mapDispatchToProps)(GetStartedInfoGeneral);